import { useId } from 'react'

type Option = { id: string, label: string }

type Props = {
  title: string
  options: Option[]
  selected: readonly string[]
  onToggle: (id: string) => void
  /** Ce qu'affiche le groupe sans option (aucun parcours, aucun groupe…). */
  empty?: string
}

/**
 * Une liste de cases à cocher sous un intitulé, annoncé au lecteur d'écran avec
 * chaque case (RGAA 11.5). Défile au-delà d'une dizaine d'options.
 */
function CheckboxGroup({ title, options, selected, onToggle, empty }: Props) {
  const titleId = useId()
  return (
    <div className="flex flex-col gap-2">
      <p id={titleId} className="text-sm font-medium">{title}</p>
      {options.length === 0 && empty
        ? <p className="text-xs text-muted-foreground">{empty}</p>
        : (
            <div role="group" aria-labelledby={titleId} className="flex max-h-60 flex-col gap-1.5 overflow-y-auto">
              {options.map(option => (
                <label key={option.id} className="flex cursor-pointer items-center gap-2 text-sm">
                  <input type="checkbox" checked={selected.includes(option.id)} onChange={() => onToggle(option.id)} />
                  {option.label}
                </label>
              ))}
            </div>
          )}
    </div>
  )
}

export default CheckboxGroup
